<template>
  <div class="soft-container">
    <tab-list></tab-list>
    <div class="soft-empty" v-if="selectSoftDetails.length === 0 && showEmpty && !redirectMode">
      <img src="~/assets/pics/noresult.png" alt="" />
      <p>{{ languages.softInstall.empty }}</p>
    </div>
    <div class="soft-empty" v-if="redirectMode">
      <i class="el-icon-loading"></i>
      <p>{{ languages.waitTip }}</p>
    </div>
    <el-scrollbar :style="{ height: listHeight }">
      <div class="single-container" v-for="item in selectSoftDetails" :key="item.id">
        <div class="soft-preview">
          <div class="soft-info">
            <img class="img-preview" @click="showItem(item)" :src="item.icon" alt="" />
            <div>
              <div class="soft-name">
                {{ item.name }}
                <span class="soft-desc">
                  {{ languages.softInstall.softsize }}: {{ item.size }}MB
                </span>
                <el-tag class="soft-feedback" size="mini" @click="handleFeedback(item)">{{
                  languages.softInstall.feedback
                }}</el-tag>
                <span>
                  <el-tag
                    type="danger"
                    effect="plain"
                    size="mini"
                    v-if="item.needAdmin === 1 && !isAdministrator"
                  >
                    {{ languages.softInstall.needAdmin }}
                  </el-tag>
                  <el-tag
                    type="danger"
                    effect="plain"
                    size="mini"
                    v-if="item.needInternet === 1 && internetAuth === 0"
                  >
                    {{ languages.softInstall.needInternet }}
                  </el-tag>
                </span>
                <span class="soft-licensed" v-if="item.progress === 4">
                  {{ languages.softInstall.licensed }}
                </span>
              </div>
              <div class="soft-desc">
                {{ languages.softInstall.updatetime }}: {{ formatDate(item.updateTime) }}
                <span v-if="item.version !== ''">( Ver: {{ item.version }} )</span>
              </div>
              <div class="soft-desc">
                {{ languages.softInstall.softdesc }}: {{ item.description }}
              </div>
              <div class="soft-desc"
              v-if="item.defaultInstallPathAdmin && item.defaultInstallPathNotAdmin">
                {{ languages.softInstall.defaultInstallPath }}:
                {{ isAdministrator ?
                item.defaultInstallPathAdmin : item.defaultInstallPathNotAdmin }}
              </div>
              <div class="soft-step" v-if="item.progress && getDaySpan(item)">
                <el-steps
                  :space="60"
                  :active="item.progress ? item.progress : 0"
                  align-center
                  finish-status="success"
                >
                  <el-step :title="languages.softInstall.request"></el-step>
                  <el-step :title="languages.softInstall.approval"></el-step>
                  <!-- <el-step :title="languages.softInstall.install"></el-step> -->
                  <el-step :title="languages.softInstall.activate"></el-step>
                </el-steps>
                <el-tag
                  v-if="item.progress == 2 && item.urgeTimes < 1"
                  :class="languages.lan === 'cn' ? 'soft-reminder' : 'soft-reminder-en'"
                  size="small"
                  type="danger"
                  @click="showRemindDialog(item)"
                  effect="plain"
                  >{{ languages.softInstall.rmind }}</el-tag
                >
                <el-tag
                  v-if="item.progress == 2 && item.urgeTimes >= 1"
                  style="cursor: default"
                  :class="languages.lan === 'cn' ? 'soft-reminder' : 'soft-reminder-en'"
                  size="small"
                  type="success"
                  effect="plain"
                  >{{ languages.softInstall.reminded }}</el-tag
                >
              </div>
            </div>
          </div>
          <div class="button-container">
            <!-- Apply Button -->
            <el-button
              v-if="item.authority === 1"
              type="primary"
              size="medium"
              :disabled="errorStatus || isRunning"
              :class="item.id !== loaddingId && isRunning ? 'is-disable' : ''"
              @click="handleApply(item)"
              >{{ languages.softInstall.apply }}</el-button
            >
            <!-- Need Administrator Button -->
             <el-button
             type="primary"
             size="medium"
             :disabled="errorStatus || isRunning"
             v-else-if="
                !uninstallData[item.regName] &&
                item.needAdmin && item.needAdmin === 1 && !isAdministrator &&
                (
                  (item.needInternet === 1 && internetAuth === 1)
                  || item.needInternet === 0 || !item.needInternet)
              "
              :class="item.id !== loaddingId && isRunning ? 'is-disable' : ''"
              @click="goApplyAdmin"
              >
              {{ languages.softInstall.apply }}
             </el-button>
             <!-- Need Internet Button -->
             <el-button
             type="primary"
             size="medium"
             :disabled="errorStatus || isRunning"
             v-else-if="
                !uninstallData[item.regName] &&
                item.needInternet && item.needInternet === 1 && internetAuth === 0 &&
                (!item.needAdmin || item.needAdmin === 0 ||
                (item.needAdmin === 1 && isAdministrator))
              "
              :class="item.id !== loaddingId && isRunning ? 'is-disable' : ''"
              @click="authApply('internet')"
              >
              {{ languages.softInstall.apply }}
             </el-button>
             <!-- Need Administrator and Internet Button -->
            <el-dropdown
              v-else-if="
                !uninstallData[item.regName] &&
                ((item.needAdmin && item.needAdmin === 1 && !isAdministrator) ||
                (item.needInternet && item.needInternet === 1 && internetAuth === 0))
              "
              class="dropdown-item"
              @command="authApply"
            >
              <el-button
                type="primary"
                size="medium"
                :disabled="(errorStatus || isRunning)"
                :loading="item.id === loaddingId"
                :class="(item.id !== loaddingId && isRunning) ? 'is-disable' : ''"
              >
                <!-- <span v-if="!isRunning">
                  <img
                    class="icon-alert"
                    v-if="
                      (item.needAdmin === 1 && isAdministrator) ||
                      (item.needInternet === 1 && internetAuth === 0)
                    "
                    src="~assets/pics/alert.png"
                    alt="alert"
                  />
                </span> -->
                {{ languages.softInstall.apply }}
              </el-button>
              <template #dropdown v-if="!isRunning">
                <el-dropdown-menu
                  style="padding: 5px 0"
                  v-if="
                    (item.needAdmin === 1 && !isAdministrator) ||
                    (item.needInternet === 1 && internetAuth === 0)
                  "
                >
                  <el-dropdown-item v-if="!isAdministrator" disabled>
                    {{ languages.softInstall.noAdmin }}
                  </el-dropdown-item>
                  <el-dropdown-item v-if="internetAuth === 0" disabled>
                    {{ languages.softInstall.noInternet }}
                  </el-dropdown-item>
                  <el-dropdown-item divided> </el-dropdown-item>
                  <el-dropdown-item v-if="!isAdministrator" command="admin">
                    {{ languages.softInstall.applyAdmin }}
                    <img class="icon-install" src="~assets/pics/arrow.png" alt="install" />
                  </el-dropdown-item>
                  <el-dropdown-item v-if="internetAuth === 0" command="internet">
                    {{ languages.softInstall.applyInternet }}
                    <img class="icon-install" src="~assets/pics/arrow.png" alt="install" />
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <!-- default Install Button -->
            <el-button
              v-else-if="item.authority === 0 && !uninstallData[item.regName]"
              type="primary"
              size="medium"
              @click="handleInstall(item)"
              :disabled="errorStatus || isRunning"
              :loading="item.id === loaddingId"
              :class="item.id !== loaddingId && isRunning ? 'is-disable' : ''"
            >
              {{
                item.id === loaddingId && isRunning
                  ? installStep(step)
                  : !item.installParams
                  ? languages.install
                  : languages.fastInstall
              }}
            </el-button>

            <!-- Installed Button -->
            <div v-else-if="item.authority === 0 && uninstallData[item.regName]">
              <el-dropdown trigger="click" class="dropdown-item" @command="handleReinstall">
                <el-button
                  type="primary"
                  size="medium"
                  :disabled="errorStatus || isRunning"
                  :loading="item.id === loaddingId"
                  :class="[
                    item.id !== loaddingId && isRunning ? 'is-disable' : '',
                    uninstallData[item.regName] ? 'is-installed' : '',
                  ]"
                >
                  {{
                    uninstallData[item.regName] && (!isRunning || item.id !== loaddingId)
                      ? languages.installed
                      : item.id === loaddingId && isRunning
                      ? installStep(step)
                      : !item.installParams
                      ? languages.install
                      : languages.fastInstall
                  }}
                  <i
                    class="el-icon-caret-bottom"
                    v-if="uninstallData[item.regName] && (item.id !== loaddingId || !isRunning)"
                  ></i>
                </el-button>
                <template #dropdown>
                  <el-dropdown-menu style="padding: 5px 0">
                    <el-dropdown-item :command="item">
                      {{ languages.reinstall }}
                      <img class="icon-install" src="~assets/pics/arrow.png" alt="install" />
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <el-button
              v-else
              type="primary"
              size="medium"
              :style="languages.lan === 'en' ? 'fontSize:12px' : ''"
              @click="goApplyPage(item)"
              >{{ languages.softInstall.remind }}
            </el-button>
            <!-- Uninstall Button -->
            <el-button
              v-if="oldUninstallBtnShowFlag"
              type="warning"
              size="medium"
              @click="uninstallConfirm(item)"
              :disabled="
                errorStatus ||
                isRunning ||
                item.authority !== 0 ||
                item.uninstall !== 1 ||
                !uninstallData[item.regName]
              "
              :class="
                (item.id !== uninstallId && isRunning) ||
                item.authority !== 0 ||
                item.uninstall !== 1 ||
                !uninstallData[item.regName]
                  ? 'is-disable'
                  : 'uninstall-btn'
              "
            >
              <i class="el-icon-loading" v-if="isUninstalling && item.id === uninstallId"></i>
              {{
                item.id === uninstallId && isRunning
                  ? installStep(step)
                  : isRunas(item.uninstallParams)
                  ? languages.uninstall
                  : languages.fastUninstall
              }}
            </el-button>
          </div>
        </div>
        <div class="percent-bar">
          <div class="down-icon" v-if="item.id === loaddingId && showProgressBar">
            <i class="el-icon-download"></i>
          </div>
          <el-tooltip
            v-if="item.id === loaddingId && showProgressBar"
            :content="languages.softInstall.downProgress + ': ' + parseInt(downPercent) + '%'"
            :visible-arrow="false"
            placement="top"
          >
            <el-progress :percentage="parseInt(downPercent)"></el-progress>
          </el-tooltip>
          <el-tooltip
            v-if="item.id === loaddingId && showProgressBar"
            :content="languages.softInstall.cancel"
            :visible-arrow="false"
            placement="bottom"
          >
            <div class="cancel-button">
              <i @click="stopDownload" class="el-icon-circle-close"></i>
            </div>
          </el-tooltip>
        </div>
      </div>
    </el-scrollbar>
    <info-dialog
      :languages="languages"
      :type="infoType"
      :confirm="infoConfirm"
      :show="dialogInfoVisible"
      :tips="infoTips"
      :submitting="submitting"
    ></info-dialog>
    <confirm-dialog
      :languages="languages"
      :type="confirmType"
      :operate="operateMethod"
      :show="dialogConfirmVisible"
      :softname="installing"
    ></confirm-dialog>
    <feedback-dialog
      :languages="languages"
      :show="dialogFeedbackVisible"
      :software="feedbackSoftware"
    ></feedback-dialog>
    <licence-apply-dialog
      :languages="languages.licenceApply"
      :lan="languages.lan"
      :user="userInfo"
      :software="applySoftware"
      :stock="licenseStock"
      :lightApprove="isLight"
      :showLong="true"
      :show="dialogLicenceVisible"
    >
    </licence-apply-dialog>
    <my-license-dialog
      :languages="languages.myLicenseDialog"
      :lan="languages.lan"
      :show="homeTemplate.showMyLicenseDialog"
    ></my-license-dialog>
    <remind-dialog
      :languages="languages.softInstall"
      :submitting="submitting"
      :show="dialogRemindVisible"
    ></remind-dialog>
  </div>
</template>

<script>
import TabList from 'components/TabList.vue';
import InfoDialog from 'components/dialogs/InfoDialog.vue';
import ConfirmDialog from 'components/dialogs/ConfirmDialog.vue';
import FeedbackDialog from 'components/dialogs/FeedbackDialog.vue';
import LicenceApplyDialog from 'components/dialogs/LicenceApplyDialog.vue';
import MyLicenseDialog from 'components/dialogs/MyLicenseDialog.vue';
import RemindDialog from 'components/dialogs/RemindDialog.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import socket from 'common/socket';
import tools from 'common/tools';
import { ubtRegister, ubtSendTrace } from 'utils/ubt';

export default {
  components: {
    TabList,
    InfoDialog,
    ConfirmDialog,
    FeedbackDialog,
    LicenceApplyDialog,
    MyLicenseDialog,
    RemindDialog,
  },
  inject: ['homeTemplate'],
  data() {
    return {
      dialogLicenceVisible: false,
      dialogRemindVisible: false,
      licenseStock: {},
      showLongTab: false,
      isMessageShow: false,
      saveMode: false,
      isAuthChecking: false,
      delayTime: 2000,
      stepId: '',
      count: 0,
      dialogInfoVisible: false,
      dialogConfirmVisible: false,
      dialogFeedbackVisible: false,
      showEmpty: false,
      screenWidth: 0,
      screenHeight: 0,
      listHeight: 0,
      applySoftware: {},
      isLight: false,
      feedbackSoftware: {},
      remindSoftware: {},
      loaddingId: '',
      uninstallId: '',
      submitting: false,
      infoTips: {},
      infoType: 'info',
      infoConfirm: false,
      step: 'check',
      tempSocketDatas: '',
      tempItem: '',
      queryAuthInterval: '',
      installing: '',
      isUninstalling: false,
      confirmType: '',
      operateMethod: 'install',
      connectSocketTimer: '',
      percentInterval: '',
      uninstallInterval: '',
      uninstallStatusInterval: '',
      downPercent: 0,
      showProgressBar: false,
      tempUninstallData: '',
      pvId: '',
      downloadRetryFlag: false,
    };
  },
  computed: {
    ...mapState([
      'debugMode',
      'homeHidden',
      'languages',
      'errorStatus',
      'userInfo',
      'selectSoftDetails',
      'isRunning',
      'softTypeList',
      'authInterval',
      'deviceName',
      'authSoftList',
      'searchValue',
      'activeTabId',
      'uninstallData',
      'isAuthTab',
      'internetAuth',
      'isAdministrator',
      'recommendSoftware',
      'recommendSoftwareEn',
      'redirectMode',
      'socketStatus',
      'isNewService',
      'oldUninstallBtnShowFlag',
    ]),
    formatDate() {
      return (data) => {
        const date = /\d{4}-\d{1,2}-\d{1,2}/g.exec(data);
        return date[0];
      };
    },
    installStep() {
      return (step) => {
        switch (step) {
          case 'check':
            return this.languages.softInstall.checking;
          case 'down':
            return this.languages.softInstall.downloading;
          case 'uninstall':
            return this.languages.softInstall.uninstalling;
          case 'cancel':
            return this.languages.softInstall.canceling;
          default:
            return this.languages.softInstall.installing;
        }
      };
    },
  },
  methods: {
    ...mapMutations([
      'setDebugData',
      'setPageNow',
      'setHomeHidden',
      'setSearchHidden',
      'setShowFooter',
      'setIsRunning',
      'updateSoftDetails',
      'setAuthInterval',
      'setSoftDetails',
      'setSelectSoftDetails',
      'setSoftSearch',
      'setSoftTabPage',
      'setFooterTips',
      'setDownloadSource',
      'setFooterWarn',
      'setAuthSoftDatas',
      'setDebugInfos',
      'setErrorTips',
      'setRedirectMode',
      'setPvId',
      'setIsAdministrator',
    ]),
    ...mapActions([
      'softwareApply',
      'userAuthQuery',
      'softwareInstall',
      'saveLog',
      'getSoftSearch',
      'getLicenseStock',
      'queryAdobeAll',
      'getLeaderAndCostCenter',
      'urgeActive',
      'isLightApprove',
      'getSoftAllHashList',
      'getFigmaPermission',
    ]),
    showRemindDialog(soft) {
      this.remindSoftware = soft;
      this.dialogRemindVisible = true;
      this.saveLog({
        title: 'ShowRemindDialog',
        target: 'Open Remind Dialog',
        description: 'User Click RemindApply Button',
        softwareName: soft.name,
        softwareId: soft.id,
        reserve1: 'SoftwareInstall > showRemindDialog',
        reserve2: soft.applyId,
      });
    },
    hideRemindDialog() {
      this.remindSoftware = {};
      this.dialogRemindVisible = false;
    },
    async handleRemind() {
      this.submitting = true;
      const applyRes = await this.urgeActive(this.remindSoftware.applyId);
      if (applyRes !== 'success') {
        this.remindSoftware = {};
        this.submitting = false;
        this.dialogRemindVisible = false;
        this.dialogInfoVisible = true;
        this.infoType = 'warn';
        this.infoTips = {
          title: this.languages.softInstall.remindFail,
          info: this.languages.softInstall.remindFailTips,
        };
        this.saveLog({
          title: 'Handle Remind Failed',
          target: 'handleRemind',
          softwareName: this.remindSoftware.softwareName,
          softwareId: this.remindSoftware.softwareId,
          description: applyRes,
          reserve1: 'SoftwareInstall > handleRemind',
          reserve2: this.remindSoftware.applyId,
        });
      } else {
        setTimeout(() => {
          this.remindSoftware = {};
          this.submitting = false;
          this.dialogRemindVisible = false;
        }, 2000);
        this.saveLog({
          title: 'Handle Remind Success',
          target: 'handleRemind',
          softwareName: this.remindSoftware.softwareName,
          softwareId: this.remindSoftware.softwareId,
          description: 'Remind Success',
          reserve1: 'SoftwareInstall > handleRemind',
          reserve2: this.remindSoftware.applyId,
        });
      }
    },
    getDaySpan(soft) {
      if (soft.progress < 4) return true;
      if (!soft.lastUpdateTime) return false;
      return tools.getDaySpan(soft.lastUpdateTime, new Date()) <= 3;
    },
    showItem(item) {
      console.log(item);
    },
    hideLicenceDialog() {
      this.dialogLicenceVisible = false;
      this.isLight = false;
      this.submitting = false;
      this.applySoftware = {};
      this.loaddingId = '';
      this.setIsRunning(false);
    },
    isRunas(param) {
      if (!param) return false;
      return param.indexOf('ISRUNAS') !== -1;
    },
    showDialog(title, info, type = 'info', confirm = false) {
      this.infoType = type;
      this.infoConfirm = confirm;
      this.infoTips = { title, info };
      this.dialogInfoVisible = true;
      /* reset the installing status */
      this.loaddingId = '';
      this.setIsRunning(false);
    },
    /* software install */
    handleInstall(item) {
      this.loaddingId = item.id;
      this.setIsRunning(true);
      if (this.isNewService) {
        this.newInstallPrecheck(this.deviceName, item);
      } else {
        this.installPrecheck(this.deviceName, item);
      }
    },
    handleReinstall(item) {
      ubtSendTrace(245278, 'sw_install', 'reinstall', item.name, item.id, '', this.pvId);
      this.handleInstall(item);
    },
    async newInstallPrecheck(pcCode, item) {
      this.tempSocketDatas = '';
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: item.id,
        pcName: pcCode,
      });
      if (res.status === 'failed') {
        /* get crypted datas failed */
        this.showDialog(
          this.languages.softInstall.installFail,
          this.languages.softInstall.contact,
          'warn',
        );
        this.saveLog({
          title: 'api_error',
          target: 'softTaskCreate',
          softwareName: item.name,
          softwareId: item.id,
          description: res.data,
          reserve1: 'SoftwareInstall > handleInstall',
        });
        this.setErrorTips(`Api Error in newInstall> ${res.error_msg}`);
        return;
      }

      const index = this.softTypeList.findIndex((itm) => item.typeId === itm.id);
      const installDatas = {
        username: this.userInfo.username,
        softid: item.id,
        regVer: item.version,
        lan: this.languages.lan,
        path: res.data.encryptPath,
        key: res.data.key,
        type: this.softTypeList[index].name,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(installDatas));
      this.step = 'check';
      this.tempSocketDatas = socketDatas;
      this.tempItem = item;

      const checkSoft = `{'name':'${item.regName}','version':'${item.version}'}`;
      const checkCommand = `({"level":"user","method":"check_version", "data":"${checkSoft}"})`;
      console.log(checkCommand);
      socket.sendSocket(2, checkCommand, (rs) => {
        const rlt = JSON.parse(rs);
        console.log('rlt', rlt);
        if (rlt.result === 'success') {
          const status = JSON.parse(rlt.data)[item.regName];
          let showTips = '';
          switch (status) {
            case '=':
              showTips = this.languages.softInstall.sameVer;
              break;
            case '<':
              showTips = this.languages.softInstall.highVer;
              break;
            case '>':
              showTips = this.languages.softInstall.lowVer;
              break;
            case '<>':
              showTips = this.languages.softInstall.hasVer;
              break;
            default:
              showTips = '';
              break;
          }
          console.log('newInstallPrecheck ======> ', item);
          if (showTips) {
            // 判断是否需要先卸载再安装
            if (item.installCheckFlag === 1) {
              this.showDialog(this.languages.softInstall.installNote, this.languages.softInstall.needUninstall, 'warn', false);
            } else {
              this.showDialog(this.languages.softInstall.installNote, showTips, 'warn', true);
            }
          } else {
            this.newDownloadSoftware();
          }
        }
      });
    },
    async newDownloadSoftware() {
      this.step = 'down';
      const downStartTime = new Date().getTime();
      const downCommand = `({"level":"user", "method":"soft_download", "data":"${this.tempSocketDatas}"})`;
      socket.sendSocket(2, downCommand, async (rs) => {
        let res = null;
        try {
          res = JSON.parse(rs);
        } catch {
          this.saveLog({
            title: 'command_error',
            target: 'newDownloadSoftware',
            softwareName: this.tempItem.name,
            softwareId: this.tempItem.id,
            description: 'download result parse failed',
            reserve1: 'SoftwareInstall > newDownloadSoftware',
            reserve2: rs,
          });
        }
        console.log('newDownloadSoftware res ===========>', res);
        if (res === null) {
          this.showDialog(
            this.languages.softInstall.installFail,
            this.languages.softInstall.contact,
            'warn',
          );
          return;
        }
        if (res.result === 'failed') {
          console.log('download error=====================', res.error);
          const { downBlock } = this.languages;
          if (res.error === 'Process Exist') {
            this.showDialog(
              this.languages.softInstall.installNote,
              this.languages.softInstall.processExist,
              'warn',
            );
          } else if (res.error.includes('Out Of Disk Space')) {
            const disk = res.error.slice(res.error.indexOf('“') + 1, res.error.indexOf('”'));
            this.showDialog(
              this.languages.softInstall.installNote,
              this.languages.softInstall.diskFull.replace(/@/g, disk),
              'warn',
            );
          } else if (res.error.toLowerCase().indexOf(downBlock) > -1) {
            // 提权重启软件模组
            this.setIsAdministrator(false);
            this.homeTemplate.initSoftModel('ads', () => {
              console.log('restart softmodel success');
              this.newDownloadSoftware();
            });
          } else {
            this.showDialog(
              this.languages.softInstall.installFail,
              this.languages.softInstall.contact,
              'warn',
            );
            this.setErrorTips(`newDownloadSoftware > ${res.error}`);
            this.tempSocketDatas = '';
            this.tempItem = '';
          }
          return;
        }
        if (res.data.includes('%') && res.type === 'Download') {
          this.showProgressBar = true;
          this.downPercent = res.data.replace('%', '');
          const totalSize = this.tempItem.size;
          const downSize = Math.round(totalSize * (Number(this.downPercent) / 100));
          if (downSize && totalSize) {
            this.setFooterTips(`${downSize}MB / ${totalSize}MB`);
            this.setDownloadSource(res.info);
          }
        }
        if (res.data === 'File Exist' || res.data === 'Download Finished') {
          this.showProgressBar = false;
          const downTime = new Date().getTime() - downStartTime;
          ubtSendTrace(
            245278,
            'sw_install',
            'download_suc',
            this.tempItem.name,
            this.tempItem.id,
            '',
            this.pvId,
          );
          this.saveLog({
            title: 'download_success',
            softwareName: this.tempItem.name,
            softwareId: this.tempItem.id,
            target: 'installSoftware',
            description: 'normal',
            reserve1: 'SoftwareInstall > newDownloadSoftware',
            reserve2: Math.round(downTime / 1000),
            reserve3: res.data === 'File Exist' ? res.data : res.info,
          });
          if (!this.isAdministrator) {
            this.homeTemplate.initSoftModel('adf', () => {
              this.newInstallSoftware();
            });
          } else {
            this.newInstallSoftware();
          }
        }
      });
    },
    async newInstallSoftware() {
      console.log('start newInstallSoftware');
      this.step = 'install';
      const userLevel = this.isAdministrator ? 'user' : 'adf';
      const installCommand = `({"level":"${userLevel}", "method":"soft_install", "data":"${this.tempSocketDatas}"})`;
      socket.sendSocket(2, installCommand, async (is) => {
        console.log('newInstallSoftware', is);
        const ires = JSON.parse(is);
        if (ires.result === 'failed') {
          if (ires.error.includes('"exitCode":1')) {
            this.saveLog({
              title: 'install_cancel',
              target: 'newInstallSoftware',
              softwareName: this.tempItem.name,
              softwareId: this.tempItem.id,
              description: `Install Cancel > ${ires.error}`,
              reserve1: 'SoftwareInstall > newInstallSoftware',
              reserve2: ires.info,
            });
            this.setDebugInfos(['newInstallSoftware Install Cancel', 'Install Canceled']);
            if (!this.isAdministrator) this.homeTemplate.initSoftModel('ads');
            this.loaddingId = '';
            this.setIsRunning(false);
            return;
          }
          let specialExitCodeFlag = false;
          if (this.tempItem.exitCode) {
            console.log('specialExitCodeFlag check start');
            let errorObject = null;
            try {
              errorObject = JSON.parse(ires.error);
            } catch {
              console.log('install result error json parse failed', ires.error);
            }
            if (errorObject != null) {
              const specialCodeList = this.tempItem.exitCode.split(',');
              if (
                errorObject.exitCode !== 0 &&
                specialCodeList.includes(errorObject.exitCode.toString())
              ) {
                specialExitCodeFlag = true;
              }
            }
          }
          this.downloadRetryFlag = !this.downloadRetryFlag;
          if (!specialExitCodeFlag) {
            if (ires.error.startsWith('Wrong Hash')) {
              if (this.downloadRetryFlag) {
                this.$message({
                  showClose: true,
                  message: this.languages.softInstall.downloadRetry,
                  duration: 5000,
                  type: 'warning',
                });
                this.saveLog({
                  title: 'download_retry',
                  target: 'newInstallSoftware',
                  softwareName: this.tempItem.name,
                  softwareId: this.tempItem.id,
                  description: `Install Retry > ${ires.error}`,
                  reserve1: 'SoftwareInstall > newInstallSoftware',
                  reserve2: ires.info,
                });
                this.newDownloadSoftware();
                return;
              }
            }
            this.setDebugInfos(['newInstallSoftware Install Error', ires.error]);
            this.setErrorTips(`Install Error > ${ires.error}`);
            this.showDialog(
              this.languages.softInstall.installFail,
              this.languages.softInstall.contact,
              'warn',
            );
            this.saveLog({
              title: 'install_error',
              target: 'newInstallSoftware',
              softwareName: this.tempItem.name,
              softwareId: this.tempItem.id,
              description: `Install Error > ${ires.error}`,
              reserve1: 'SoftwareInstall > newInstallSoftware',
              reserve2: ires.info,
            });
            if (!this.isAdministrator) this.homeTemplate.initSoftModel('ads');
            return;
          }
          this.installSuccessHaneler(ires);
        }
        if (ires.data === 'Install Success') {
          this.installSuccessHaneler(ires);
        }
      });
    },
    installSuccessHaneler(ires) {
      this.downloadRetryFlag = false;
      let showInfo = this.languages.softInstall.installInfo;
      if (this.tempItem.softType && this.tempItem.softType !== 0) {
        showInfo += `\n${this.languages.softInstall.authTips}`;
      }
      if (this.tempItem.restart) {
        showInfo += `\n${this.languages.softInstall.needRestart}`;
      }
      this.showDialog(this.languages.softInstall.installed, showInfo);
      ubtSendTrace(
        245278,
        'sw_install',
        'install_suc',
        this.tempItem.name,
        this.tempItem.id,
        '',
        this.pvId,
      );
      this.saveLog({
        title: 'install_success',
        target: 'newInstallSoftware',
        softwareName: this.tempItem.name,
        softwareId: this.tempItem.id,
        description: 'Install Success',
        reserve1: 'SoftwareInstall > newInstallSoftware',
        reserve2: ires.info,
      });
      this.step = 'check';
      this.tempSocketDatas = '';
      this.tempItem = '';
      this.setFooterTips('');
      this.handleClean();
      if (this.isAdministrator) {
        this.homeTemplate.checkUninstallResult();
        return;
      }
      this.homeTemplate.initSoftModel('ads', (res) => {
        console.log('res!', res);
        this.homeTemplate.checkUninstallResult();
      });
    },
    uninstallConfirm(item) {
      this.tempUninstallData = item;
      this.operateMethod = 'uninstall';
      this.dialogConfirmVisible = true;
      this.installing = item.name;
    },
    handleUninstall() {
      this.dialogConfirmVisible = false;
      if (!this.isAdministrator && this.isNewService) {
        this.homeTemplate.initSoftModel('adf', () => {
          this.handleUninstallSoftware();
        });
      } else {
        this.handleUninstallSoftware();
      }
    },
    async handleUninstallSoftware() {
      const item = this.tempUninstallData;
      this.step = 'uninstall';
      let uninstallIndex = 0;
      this.uninstallInterval = setInterval(() => {
        uninstallIndex += 1;
        if (uninstallIndex > 300) {
          clearInterval(this.uninstallInterval);
          this.showDialog(
            this.languages.softInstall.uninstallNote,
            `${this.languages.softInstall.uninstallTimeout}, ${this.languages.softInstall.retry}`,
            'warn',
          );
          this.resetUninstallData();
        }
      }, 1000);
      if (uninstallIndex >= 300) return;
      if (item.uninstall !== 1) return;
      this.uninstallId = item.id;
      this.isUninstalling = true;
      this.setIsRunning(true);
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: item.id,
        pcName: this.deviceName,
      });
      if (res.status === 'failed') {
        this.step = 'check';
        /* get crypted datas failed */
        this.showDialog(
          this.languages.softInstall.uninstallFail,
          this.languages.softInstall.contact,
          'warn',
        );
        this.saveLog({
          title: 'api_error',
          target: 'handleUninstallSoftware',
          softwareName: item.name,
          softwareId: item.id,
          description: res.data,
          reserve1: 'SoftwareInstall > handleUninstallSoftware',
        });
        this.resetUninstallData();
        return;
      }
      const uninstallHashList = await this.getSoftAllHashList(item.id);
      const uninstallDatas = {
        username: this.userInfo.username,
        regName: item.regName,
        softid: item.id,
        lan: this.languages.lan,
        path: res.data.encryptPath,
        key: res.data.key,
        type: '',
        uninstallHashList,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(uninstallDatas));
      const level = this.isAdministrator ? 'user' : 'adf';
      const command = `({"level":"${level}", "method":"soft_uninstall", "data":"${socketDatas}"})`;

      const uninstallMethod = !this.isRunas(item.uninstallParams)
        ? 'idesk_uninstall'
        : 'idesk_uninstall2';
      const uninstallCmd = this.isNewService ? command : `${uninstallMethod}(${socketDatas})`;
      const port = this.isNewService ? 2 : 0;
      socket.sendSocket(port, uninstallCmd, async (rs) => {
        if (this.isNewService) {
          const uRes = JSON.parse(rs);
          if (uRes.result === 'success' && uRes.data === 'Uninstall Finished') {
            await tools.sleep(3000);
            this.homeTemplate.checkUninstallResult();
            await tools.sleep(1000);
            if (!this.uninstallData[item.regName]) {
              this.showDialog(
                this.languages.softInstall.uninstallNote,
                this.languages.softInstall.uninstalled,
                'info',
              );
              ubtSendTrace(
                245278,
                'sw_install',
                'uninstall_suc',
                this.tempItem.name,
                this.tempItem.id,
                '',
                this.pvId,
              );
              this.saveLog({
                title: 'uninstall_success',
                target: 'handleUninstallSoftware',
                softwareName: item.name,
                softwareId: item.id,
                description: 'normal',
                reserve1: 'SoftwareInstall > handleUninstallSoftware',
                reserve2: rs.time,
              });
            }
            this.resetUninstallData();
            return;
          }
          this.setDebugInfos(['SoftwareUninstall', uRes.error]);
          this.setErrorTips(uRes.error);
          if (uRes.error !== '') {
            if (uRes.error === 'Process Exist') {
              this.showDialog(
                this.languages.softInstall.uninstallNote,
                this.languages.softInstall.processExist,
                'warn',
              );
            } else {
              this.showDialog(
                this.languages.softInstall.uninstallFail,
                this.languages.softInstall.contact,
                'warn',
              );
              this.saveLog({
                title: 'command_error',
                target: 'handleUninstallSoftware',
                softwareName: item.name,
                softwareId: item.id,
                description: uRes.error,
                reserve1: 'SoftwareInstall > handleUninstallSoftware',
              });
            }
            this.resetUninstallData();
            return;
          }
          return;
        }
        console.log('Old Service handleUninstall');
        if (rs.result === 'failed') {
          this.setDebugInfos(['SoftwareUninstall', rs.error_msg]);
          this.setErrorTips(rs.error_msg);
          if (rs.error_msg === 'process exist') {
            this.showDialog(
              this.languages.softInstall.uninstallNote,
              this.languages.softInstall.processExist,
              'warn',
            );
            this.resetUninstallData();
            return;
          }
          this.showDialog(
            this.languages.softInstall.uninstallFail,
            this.languages.softInstall.contact,
            'warn',
          );
          this.saveLog({
            title: 'uninstall_error',
            target: 'uninstallSoftware',
            softwareName: item.name,
            softwareId: item.id,
            description: rs.error_msg,
            reserve1: 'SoftwareInstall > handleUninstallSoftware',
          });
          this.resetUninstallData();
        } else {
          let checkCount = 0;
          this.saveMode = true;
          this.uninstallStatusInterval = setInterval(() => {
            checkCount += 1;
            if (checkCount > 15) {
              clearInterval(this.uninstallStatusInterval);
              this.resetUninstallData();
              return;
            }
            this.homeTemplate.checkUninstallResult();
            if (!this.uninstallData[item.regName]) {
              clearInterval(this.uninstallStatusInterval);
              this.showDialog(
                this.languages.softInstall.uninstallNote,
                this.languages.softInstall.uninstalled,
                'info',
              );
              // this.$message.success(this.languages.softInstall.uninstalled);
              if (this.saveMode) {
                this.saveMode = false;
                ubtSendTrace(
                  245278,
                  'sw_install',
                  'uninstall_suc',
                  this.tempItem.name,
                  this.tempItem.id,
                  '',
                  this.pvId,
                );
                this.saveLog({
                  title: 'uninstall_success',
                  softwareName: item.name,
                  softwareId: item.id,
                  target: 'uninstallSoftware',
                  description: 'normal',
                  reserve1: 'SoftwareInstall > handleUninstallSoftware',
                  reserve2: rs.time,
                });
              }
              this.resetUninstallData();
            }
          }, 2000);
        }
      });
    },
    resetUninstallData() {
      this.saveMode = false;
      this.step = 'check';
      this.uninstallId = '';
      this.tempUninstallData = '';
      this.setIsRunning(false);
      this.isUninstalling = false;
      if (!this.isAdministrator && this.isNewService) this.homeTemplate.initSoftModel('ads');
      clearInterval(this.uninstallInterval);
    },
    /* software installing */
    async installPrecheck(pcCode, item) {
      this.tempSocketDatas = '';
      /* 3. get the software crypted datas from api */
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: item.id,
        pcName: pcCode,
      });
      // console.log('installPrecheck', res);
      if (res.status === 'failed') {
        /* get crypted datas failed */
        this.showDialog(
          this.languages.softInstall.installFail,
          this.languages.softInstall.contact,
          'warn',
        );
        this.saveLog({
          title: 'api_error',
          target: 'installPrecheck',
          softwareName: item.name,
          softwareId: item.id,
          description: res.data,
          reserve1: 'SoftwareInstall > installPrecheck',
        });
        return;
      }
      /* 4. to get the datas for local service installation */
      const index = this.softTypeList.findIndex((itm) => item.typeId === itm.id);
      const installDatas = {
        username: this.userInfo.username,
        softid: item.id,
        regVer: item.version,
        lan: this.languages.lan,
        path: res.data.encryptPath,
        key: res.data.key,
        type: this.softTypeList[index].name,
      };
      const socketDatas = tools.toUnicode(JSON.stringify(installDatas));
      if (this.debugMode) {
        this.setDebugData(socketDatas);
      }
      /* 5. send download command to local service with install datas */
      this.step = 'check';
      this.tempSocketDatas = socketDatas;
      this.tempItem = item;
      socket.sendSocket(0, `idesk_check(${socketDatas})`, (rs) => {
        console.log('idesk_check', rs);
        const status = rs.result;
        if (status === 'failed') {
          switch (rs.error_msg) {
            case 'disk full':
              this.showDialog(
                this.languages.softInstall.installNote,
                this.languages.softInstall.diskFull.replace(/@/g, rs.disk),
                'warn',
              );
              break;
            case 'process exist':
              this.showDialog(
                this.languages.softInstall.installNote,
                this.languages.softInstall.processExist,
                'warn',
              );
              break;
            default:
              this.showDialog(
                this.languages.softInstall.installFail,
                this.languages.softInstall.contact,
                'warn',
              );
              break;
          }
          this.saveLog({
            title: 'check_error',
            target: 'installPrecheck',
            softwareName: item.name,
            softwareId: item.id,
            description: rs.error_msg,
            reserve1: 'SoftwareInstall > installPrecheck',
          });
          this.tempSocketDatas = '';
          this.tempItem = '';
          return;
        }
        let showTips = '';
        switch (status) {
          case '=':
            showTips = this.languages.softInstall.sameVer;
            break;
          case '<':
            showTips = this.languages.softInstall.highVer;
            break;
          case '>':
            showTips = this.languages.softInstall.lowVer;
            break;
          case '<>':
            showTips = this.languages.softInstall.hasVer;
            break;
          default:
            showTips = '';
            break;
        }
        if (showTips) {
          this.showDialog(this.languages.softInstall.installNote, showTips, 'warn', true);
        } else {
          this.installSoftware();
        }
      });
    },
    installSoftware() {
      this.isMessageShow = true;
      this.saveMode = true;
      // console.log('installSoftware', this.tempItem);
      this.loaddingId = this.tempItem.id;
      this.setIsRunning(true);
      this.dialogInfoVisible = false;
      this.step = 'down';
      this.tempItem.lan = this.languages.lan;
      if (this.isNewService) {
        this.newDownloadSoftware();
        return;
      }
      // console.log(this.tempSocketDatas);
      socket.sendSocket(0, `idesk_download2(${this.tempSocketDatas})`, (res) => {
        const status = res.result;
        console.log('> idesk_download2', res);
        if (status === 'failed') {
          this.setDebugInfos(['SoftwareInstall > download2', res.error_msg]);
          this.setErrorTips(res.error_msg);
          this.setDebugData(this.tempSocketDatas);
          this.showDialog(
            this.languages.softInstall.installFail,
            this.languages.softInstall.contact,
            'warn',
          );
          ubtSendTrace(
            245278,
            'sw_install',
            'download_fail',
            this.tempItem.name,
            this.tempItem.id,
            '',
            this.pvId,
            res.error_msg,
          );
          this.saveLog({
            title: 'download_error',
            softwareName: this.tempItem.name,
            softwareId: this.tempItem.id,
            target: 'installSoftware',
            description: res.error_msg,
            reserve1: 'SoftwareInstall > installSoftware',
          });
          this.step = 'check';
          this.handleClean();
          return;
        }
        const { source, downway } = res;
        let time = '';
        if (status === 'download start') {
          this.showProgressBar = true;
          let downIndex = 0;
          this.percentInterval = setInterval(() => {
            downIndex += 1;
            if (downIndex >= 12000) {
              clearInterval(this.percentInterval);
              this.showDialog(
                this.languages.softInstall.downloadNote,
                `${this.languages.softInstall.downTimeout}, ${this.languages.softInstall.retry}`,
                'warn',
              );
              if (this.saveMode) {
                this.saveMode = false;
                ubtSendTrace(
                  245278,
                  'sw_install',
                  'download_fail',
                  this.tempItem.name,
                  this.tempItem.id,
                  '',
                  this.pvId,
                  'download timeout',
                );
                this.saveLog({
                  title: 'download_error',
                  target: 'installSoftware',
                  softwareName: this.tempItem.name,
                  softwareId: this.tempItem.id,
                  description: 'download timeout',
                  reserve1: 'SoftwareInstall > installSoftware',
                });
              }
              this.downPercent = 0;
              this.setFooterTips('');
              this.showProgressBar = false;
              this.handleClean();
              return;
            }
            socket.sendSocket(0, 'idesk_query(percent)', (prs) => {
              if (prs.percent === 'error') {
                clearInterval(this.percentInterval);
                this.showDialog(
                  this.languages.softInstall.downloadNote,
                  `${this.languages.softInstall.downFailed}, ${this.languages.softInstall.retry}`,
                  'warn',
                );
                if (this.saveMode) {
                  this.saveMode = false;
                  ubtSendTrace(
                    245278,
                    'sw_install',
                    'download_fail',
                    this.tempItem.name,
                    this.tempItem.id,
                    '',
                    this.pvId,
                    'download percent error',
                  );
                  this.saveLog({
                    title: 'download_error',
                    target: 'installSoftware',
                    softwareName: this.tempItem.name,
                    softwareId: this.tempItem.id,
                    description: 'download percent error',
                    reserve1: 'SoftwareInstall > installSoftware',
                  });
                }
                this.downPercent = 0;
                this.setFooterTips('');
                this.showProgressBar = false;
                this.handleClean();
                return;
              }
              const downSize = Math.round((prs.size / 1024 / 1024) * 10) / 10;
              const totalSize = Math.round((prs.total / 1024 / 1024) * 10) / 10;

              if (downSize && totalSize) {
                this.setFooterTips(`${downSize}MB / ${totalSize}MB`);
                this.setDownloadSource(source);
              }
              if (prs.percent) this.downPercent = prs.percent;
              if (this.downPercent === '100') {
                clearInterval(this.percentInterval);
                time = prs.downTime;
                this.downPercent = 0;
                if (this.saveMode) {
                  this.saveMode = false;
                  ubtSendTrace(
                    245278,
                    'sw_install',
                    'download_suc',
                    this.tempItem.name,
                    this.tempItem.id,
                    '',
                    this.pvId,
                  );
                  this.saveLog({
                    title: 'download_success',
                    softwareName: this.tempItem.name,
                    softwareId: this.tempItem.id,
                    target: 'installSoftware',
                    description: 'normal',
                    reserve1: 'SoftwareInstall > installSoftware',
                    reserve2: time,
                    reserve3: source,
                    reserve4: downway,
                  });
                }
                this.setFooterTips('');
                this.showProgressBar = false;

                /* 6. send install command to local service with install datas */
                if (this.tempItem.showTips) {
                  this.$message({
                    showClose: true,
                    message: this.tempItem.showTips,
                    type: 'success',
                    duration: 0,
                  });
                }
                setTimeout(() => {
                  this.step = 'install';
                  this.saveMode = true;
                  if (!this.tempItem.installParams && this.isMessageShow) {
                    this.$message.warning({
                      message: this.languages.softInstall.installTip,
                      duration: this.languages.installTip || 5000,
                      showClose: true,
                    });
                    this.isMessageShow = false;
                  }
                  socket.sendSocket(0, `idesk_install(${this.tempSocketDatas})`, (irs) => {
                    console.log('idesk_install >>> ', irs);
                    const sts = irs.result;
                    if (sts !== 'install success') {
                      this.setDebugInfos(['SoftwareIninstall', irs.error_msg]);
                      this.setErrorTips(irs.error_msg);
                      this.showDialog(
                        this.languages.softInstall.installFail,
                        this.languages.softInstall.contact,
                        'warn',
                      );
                      if (Number(irs.error_msg)) {
                        if (this.saveMode) {
                          this.saveMode = false;
                          this.saveLog({
                            title: 'install_cancel',
                            target: 'installSoftware',
                            softwareName: this.tempItem.name,
                            softwareId: this.tempItem.id,
                            description: irs.error_msg,
                            reserve1: 'SoftwareInstall > installSoftware',
                          });
                        }
                      } else if (this.saveMode) {
                        this.saveMode = false;
                        this.saveLog({
                          title: 'install_error',
                          target: 'installSoftware',
                          softwareName: this.tempItem.name,
                          softwareId: this.tempItem.id,
                          description: irs.error_msg,
                          reserve1: 'SoftwareInstall > installSoftware',
                        });
                      }
                    } else {
                      const showInfo =
                        this.tempItem.softType && this.tempItem.softType !== 0
                          ? `${this.languages.softInstall.installInfo}\n${this.languages.softInstall.authTips}`
                          : this.languages.softInstall.installInfo;
                      this.showDialog(this.languages.softInstall.installed, showInfo);
                      if (this.saveMode) {
                        this.saveMode = false;
                        ubtSendTrace(
                          245278,
                          'sw_install',
                          'install_suc',
                          this.tempItem.name,
                          this.tempItem.id,
                          '',
                          this.pvId,
                        );
                        this.saveLog({
                          title: 'install_success',
                          target: 'installSoftware',
                          softwareName: this.tempItem.name,
                          softwareId: this.tempItem.id,
                          description: 'normal',
                          reserve1: time,
                          reserve2: irs.time,
                          reserve3: source,
                          reserve4: downway,
                        });
                      }
                    }
                    this.step = 'check';
                    this.tempSocketDatas = '';
                    this.tempItem = '';
                    this.setFooterTips('');
                    this.handleClean();
                    this.homeTemplate.checkUninstallResult();
                  });
                }, 2000);
              }
            });
          }, 300);
        }
      });
    },
    /* confirm message before software application */
    async handleApply(soft) {
      this.licenseStock = {};
      this.showLongTab = false;
      const softwareId = soft.id;
      const empCode = this.userInfo.empcode;
      const result = await this.getLicenseStock(`?softwareId=${softwareId}&empCode=${empCode}`);
      if (!result.code || result.code !== 1) {
        this.dialogInfoVisible = true;
        this.infoType = 'warn';
        this.infoTips = {
          title: this.languages.softInstall.applyFail,
          info: this.languages.softInstall.contact,
        };
        this.saveLog({
          title: 'api_error',
          target: 'handleApply',
          softwareName: this.applySoftware.softwareName,
          softwareId: this.applySoftware.softwareId,
          description: result.msg ? result.msg : result,
          reserve1: 'SoftwareInstall > handleApply',
        });
        this.setErrorTips(result.msg ? result.msg : result);
        return;
      }
      this.isLight = await this.isLightApprove(soft.id);
      this.applySoftware = soft;
      this.showLongTab = soft.jobFamily && soft.jobFamily.includes(this.userInfo.jobFamily);
      this.licenseStock = result.data;
      this.dialogLicenceVisible = true;
      this.saveLog({
        title: 'LicenceApply',
        target: 'Open LicenceApply Dialog',
        description: 'User Click LicenceApply Button',
        softwareName: soft.name,
        softwareId: soft.id,
        reserve1: 'SoftwareInstall > handleApply',
      });
    },
    async submitApply(type, assign, duration, reason) {
      this.infoType = 'info';
      if (type === 'Log') {
        this.dialogInfoVisible = true;
        this.infoTips = {
          title: this.languages.licenceApply.logNote,
          info: this.languages.licenceApply.logSuccess,
        };
        return;
      }
      this.applySoftware.reason = reason || this.languages.licenceApply.reason;
      this.applySoftware.assign = assign;
      this.applySoftware.duration = duration;
      this.applySoftware.softwareName = this.applySoftware.name;
      this.applySoftware.softwareId = this.applySoftware.id;
      this.applySoftware.pcName = this.deviceName;
      this.applySoftware.empCode = this.userInfo.empcode;
      this.applySoftware.username = this.userInfo.username;
      this.applySoftware.displayName = this.userInfo.displayName;
      this.applySoftware.jobFamily = this.userInfo.jobFamily;

      this.submitting = true;
      const result = await this.softwareApply({ ...this.applySoftware });
      this.dialogInfoVisible = true;
      if (result.status === 'failed') {
        this.infoType = 'warn';
        this.infoTips = {
          title: this.languages.softInstall.applyFail,
          info: this.languages.softInstall.contact,
        };
        this.saveLog({
          title: 'api_error',
          softwareName: this.applySoftware.softwareName,
          softwareId: this.applySoftware.softwareId,
          target: 'SubmitApply',
          description: result.data,
          reserve1: 'SoftwareInstall > submitApply',
        });
      } else {
        this.infoType = 'info';
        this.infoTips = {
          title: this.languages.softInstall.applyNote,
          info: this.languages.softInstall.applySuccess,
        };
        this.updateSoftDetails({ index: this.loaddingId, key: 'authority', val: 2 });
        this.saveLog({
          title: 'apply_success',
          softwareName: this.applySoftware.softwareName,
          softwareId: this.applySoftware.softwareId,
          target: 'SubmitApply',
          description: 'Apply Success',
          reserve1: 'SoftwareInstall > submitApply',
        });
        this.setAuthInterval(true);
        if (!this.isAuthChecking) {
          this.runAuthInterval();
        }
        setTimeout(() => {
          this.handleReload();
        }, this.delayTime + 2000);
      }
      this.loaddingId = '';
      this.setIsRunning(false);
      this.dialogLicenceVisible = false;
      this.submitting = false;
    },
    hideInfoDialog() {
      this.dialogInfoVisible = false;
    },
    hideConfirmDialog() {
      this.dialogConfirmVisible = false;
    },
    hideFeedbackDialog() {
      this.feedbackSoftware = {};
      this.dialogFeedbackVisible = false;
    },
    handleFeedback(item) {
      ubtSendTrace(245278, 'sw_install', 'feedback', item.name, item.id, '', this.pvId);
      this.feedbackSoftware = item;
      this.dialogFeedbackVisible = true;
    },

    /* to set the softlist container height */
    getSoftListHeight() {
      const desc = document.body.clientWidth > 922 ? 186 : 205;
      this.listHeight = `${document.body.clientHeight - desc}px`;
      window.onresize = () => (() => {
        // const desc2 = document.body.clientWidth > 922 ? 170 : 205;
        this.listHeight = `${document.body.clientHeight - desc}px`;
      })();
    },
    runAuthInterval() {
      console.log('start authInterval');
      this.isAuthChecking = true;
      this.queryAuthInterval = setInterval(async () => {
        const { lan } = this.languages;
        const softDatas = window.localStorage.getItem(`${lan}_datas`);
        this.setSoftDetails(JSON.parse(softDatas));
        this.setAuthSoftDatas(this.selectSoftDetails);
        if (this.authInterval) {
          const queryData = {
            empCode: this.userInfo.empcode,
            pcName: this.deviceName,
          };
          await this.userAuthQuery(queryData);
          if (this.authSoftList.length > 0) {
            this.authSoftList.forEach(async (item) => {
              /* 0: install button; 1: apply button; 2: applying button */
              let authority = 1;
              if (item.status === 0 || item.status === 1) {
                authority = item.progress === 0 || item.progress === 1 ? 2 : 0;
              }
              this.updateSoftDetails({
                index: item.softwareId,
                key: 'authority',
                val: authority,
              });
            });
          }
        } else {
          console.log('Interval destoryed');
          console.log('this.queryAuthInterval ===========================', this.queryAuthInterval);
          clearInterval(this.queryAuthInterval);
          this.isAuthChecking = false;
          setTimeout(async () => {
            const queryData = {
              empCode: this.userInfo.empcode,
              pcName: this.deviceName,
            };
            await this.userAuthQuery(queryData);
          }, 2000);
        }
        if (this.searchValue) {
          await this.getSoftSearch(this.searchValue);
          // this.setRedirectMode(false);
          // this.setIsRunning(false);
        } else {
          await this.setSelectSoftDetails(this.activeTabId);
          // this.setRedirectMode(false);
          // this.setIsRunning(false);
        }
        this.setRedirectMode(false);
      }, this.delayTime);
    },
    authApply(type) {
      if (type === 'internet') {
        tools.openUrl(this.languages.softInstall.internetApplyUrl);
        this.saveLog({
          title: 'Apply Internet',
          target: 'applyInternet',
          description: 'User Apply Internet Permission',
          reserve1: 'SoftwareInstall >  authApply',
        });
        return;
      }
      this.goApplyAdmin();
    },
    goApplyAdmin() {
      // this.$router.push('/home_grid');
      this.homeTemplate.goHome();
      this.saveLog({
        title: 'Open Apply Administrator Dialog',
        target: 'applyPcAdmin',
        description: 'User Apply Administrator Permission',
        reserve1: 'SoftwareInstall >  authApply',
      });
      setTimeout(() => {
        this.$root.$emit('goApply', 'add_admin');
      }, 300);
    },
    goApplyPage(item) {
      const authSoft = this.authSoftList.filter((soft) => soft.softwareId === item.id);
      if (authSoft.length === 1) {
        // 老EForm单子
        if (authSoft[0].applyId.startsWith('IDK')) {
          tools.openUrl(`${this.languages.applyUrl}&title=${authSoft[0].applyId}`);
        } else {
          // 新OA单子
          tools.openUrl(`${this.languages.oaDomain}/oa/uui/com/sms/newctripoa/search/activity.html?activityCode=${authSoft[0].applyId}`);
        }
      }
    },
    stopDownload() {
      this.step = 'cancel';
      clearInterval(this.percentInterval);
      this.downPercent = 0;
      this.setFooterTips('');
      this.showProgressBar = false;
      if (this.isNewService) {
        const command = '({"level":"user", "method":"download_cancel", "data":""})';
        socket.sendSocket(2, command, (res) => {
          if (JSON.parse(res).data === 'Download Canceled') {
            this.handleClean();
          }
        });
        return;
      }
      try {
        socket.sendSocket(0, 'idesk_query(stopdown)');
      } catch (error) {
        console.log('error', error);
      } finally {
        this.connectSocketTimer = setInterval(async () => {
          await socket.initSocket(0);
          if (this.socketStatus[0].socket !== '' && this.socketStatus[0].readyState === 1) {
            clearInterval(this.connectSocketTimer);
            this.handleClean();
          }
        }, 1000);
      }
    },
    handleClean() {
      this.downPercent = 0;
      this.isMessageShow = false;
      if (this.isNewService) {
        this.step = 'check';
        this.loaddingId = '';
        this.setIsRunning(false);
        return;
      }
      socket.sendSocket(0, 'idesk_query(clean)', (res) => {
        console.log('handleClean', res);
        // if (res.clean === 'ok') {
        this.step = 'check';
        this.loaddingId = '';
        this.setIsRunning(false);
        // }
      });
    },
    handleReload() {
      console.log('handleReload');
      const id = this.activeTabId;
      this.setSoftTabPage(id);
      this.setSelectSoftDetails(id);
      const { lan } = this.languages;
      const softDatas = window.localStorage.getItem(`${lan}_datas`);
      this.setSoftDetails(JSON.parse(softDatas));
    },
  },
  async created() {
    this.queryAdobeAll(this.userInfo.empcode);
    this.getFigmaPermission();
    this.getLeaderAndCostCenter();
    this.setPageNow('SoftwareInstall');
    this.setHomeHidden(false);
    this.setSearchHidden(false);
    this.setShowFooter(true);
    const recommendList =
      this.languages.lan === 'cn' ? this.recommendSoftware : this.recommendSoftwareEn;
    this.setSoftTabPage(recommendList.length > 0 ? 'recommend' : 'common');
    if (!this.redirectMode) {
      this.setSelectSoftDetails(recommendList.length > 0 ? 'recommend' : 'common');
    }
    await this.homeTemplate.getSoftDatas(this.languages.lan);
    if (this.redirectMode) {
      this.setIsRunning(true);
    } else {
      await this.homeTemplate.checkUninstallResult();
    }
    /* to hide the empty pic before softlist create */
    setTimeout(() => {
      this.showEmpty = true;
      /* to run auth interval if has auth applies */
      this.runAuthInterval();
    }, 2000);
    this.setIsRunning(false);
    this.pvId = ubtRegister('Install');
    this.setPvId(this.pvId);
  },
  mounted() {
    this.getSoftListHeight();
  },
  beforeDestroy() {
    this.setSoftSearch('');
    console.log('>>> Interval destoryed');
    clearInterval(this.queryAuthInterval);
    this.isAuthChecking = false;
    clearInterval(this.connectSocketTimer);
    clearInterval(this.percentInterval);
    clearInterval(this.uninstallInterval);
    clearInterval(this.uninstallStatusInterval);
    const recommendList =
      this.languages.lan === 'cn' ? this.recommendSoftware : this.recommendSoftwareEn;
    console.log('recommendList', recommendList);
    this.setSoftTabPage(recommendList.length > 0 ? 'recommend' : 'common');
    this.setSelectSoftDetails(recommendList.length > 0 ? 'recommend' : 'common');
  },
};
</script>

<style lang="scss" scoped>
.soft-container {
  background-color: #fff;
  padding: 0 10px;
  position: relative;
}
.is-disable {
  background-color: #999 !important;
  border: none !important;
}
.uninstall-btn {
  margin-left: 10px;
}
.is-installed {
  background-color: #7ea3ea !important;
  border: none !important;
}
.is-hidden {
  opacity: 0;
}
.el-icon-loading {
  margin-right: 1px;
}
.soft-empty {
  display: flex;
  flex-direction: column;
  position: absolute;
  text-align: center;
  align-items: center;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  img {
    width: 200px;
    height: 200px;
  }
  .el-icon-loading {
    font-size: 70px;
    color: #ccc;
  }
  p {
    color: #999;
  }
}
.soft-preview {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .soft-info {
    display: flex;
  }
  .img-preview {
    width: 48px;
    height: 48px;
    margin-right: 20px;
    margin-top: 5px;
  }
  .soft-name {
    font-weight: 700;
    line-height: 24px;
    color: #333;
    span {
      margin-left: 5px;
      // color: #409bff;
      font-weight: 400;
      // font-size: 13px;
    }
    .soft-licensed {
      color: #ff6600;
      border: 1px solid #ff6600;
      border-radius: 12px;
      font-size: 12px !important;
      padding: 0 5px;
    }
  }
  .soft-desc {
    line-height: 16px;
    font-size: 13px;
    color: #999;
    max-width: 600px;
  }
  .soft-feedback {
    cursor: pointer;
  }
  .soft-step {
    position: absolute;
    right: 260px;
    top: 20px;
    width: 250px;
    .soft-reminder,
    .soft-reminder-en {
      position: absolute;
      right: 30px;
      cursor: pointer;
      text-align: center;
      top: 0;
    }
    .soft-reminder-en {
      right: 10px;
    }
  }
}
.single-container {
  // height: 86px;
  height: 100%;
  padding-top: 10px;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  position: relative;
  margin-bottom: -1px;
  margin-left: 2px;
  margin-right: 5px;
}
.percent-bar {
  position: absolute;
  padding: 0 80px 0 95px;
  left: 0;
  right: 0;
  bottom: 5px;
}
.down-icon {
  position: absolute;
  left: 75px;
  color: #333;
}
.cancel-button {
  position: absolute;
  cursor: pointer;
  right: 65px;
  bottom: -2px;
}
.button-container {
  display: flex;
  position: absolute;
  right: 10px;
  .dropdown-item {
    // margin-right: 10px;
    position: relative;
    .el-icon-caret-bottom {
      position: absolute;
      right: 6px;
    }
  }
}
.icon-install {
  position: relative;
  top: 3px;
  height: 18px;
  left: 10px;
}
.icon-alert {
  position: absolute;
  left: 5px;
  top: 4px;
  height: 24px;
}
.el-icon-caret-bottom {
  height: 24px;
  width: 22px;
  margin-top: -10px;
  padding-top: 10px;
  margin-right: -6px;
  background: #6583bc;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
</style>
